import { create } from "zustand";

// Global store for quantity edit modal state
// This survives component remounts (tablet double-tap issue)
const useQuantityModalStore = create((set) => ({
  // Modal visibility and data
  visible: false,
  orderId: null,
  currentQuantity: 0,
  orderType: null,
  price: 0,
  symbol: null,
  order: null,

  // Open the modal with order data
  openModal: (order) => {
    const orderPrice =
      order.orderType === "STOPLIMIT"
        ? order.stop || order.price || 0
        : order.limit || order.price || 0;
    set({
      visible: true,
      orderId: order.id,
      currentQuantity: order.quantity,
      orderType: order.orderType,
      price: orderPrice,
      symbol: order.symbol,
      order: order,
    });
  },

  // Close the modal and reset state
  closeModal: () => {
    set({
      visible: false,
      orderId: null,
      currentQuantity: 0,
      orderType: null,
      price: 0,
      symbol: null,
      order: null,
    });
  },
}));

export default useQuantityModalStore;
